export class TwoFactorEmailDeleteRequest {
  constructor(public userVerificationToken: string) {}
}
